"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormSubSelectionsSelect = exports.createFormSubSelectionsRadio = void 0;
var messages_1 = require("./messages");
var createFormSubSelectionsRadio = function (obj) {
    var subSelectionsObj = [];
    obj.forEach(function (item) {
        var message = messages_1.getFormattedMessage(item === null || item === void 0 ? void 0 : item.displayName);
        subSelectionsObj.push([message, "" + (item === null || item === void 0 ? void 0 : item.value)]);
    });
    return subSelectionsObj;
};
exports.createFormSubSelectionsRadio = createFormSubSelectionsRadio;
var createFormSubSelectionsSelect = function (obj, intl) {
    var subSelectionsObj = [];
    obj.forEach(function (item) {
        var message = messages_1.getFormatMessage(item === null || item === void 0 ? void 0 : item.displayName, intl);
        subSelectionsObj.push({
            displayName: message,
            value: message,
        });
    });
    return subSelectionsObj;
};
exports.createFormSubSelectionsSelect = createFormSubSelectionsSelect;
//# sourceMappingURL=createFormElements.js.map